<div>
<form #passwordForm="ngForm">
  <div>ルーム名：{{room.roomName}}</div>
  <div>パスワード: <input [(ngModel)]="inputPassword" (input)="onInputChange($event.target.value)" [ngModelOptions]="{standalone: true}" placeholder="パスワード" /></div>
  <button type="submit" (click)="submit()">送信</button>
  <button type="submit" (click)="cancel()">キャンセル</button>
</form>
{{help}}
</div>
